import { REGISTER, LOGIN, LOGOUT } from './actions';
import { AuthProps, AuthActionProps } from 'types/auth';

export const initialState: AuthProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  modules: null
};

const auth = (state = initialState, action: AuthActionProps) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload!;
      return {
        ...state,
        user
      };
    }
    case LOGIN: {
      const { user, modules } = action.payload!;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user,
        modules: modules !== undefined ? modules : state.modules
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default auth;
